'use strict';

module.exports = {
  template: require('./cn-summary-form.html'),
  controller: require('./cn-summary-form.controller'),
  controllerAs: 'vm',

  bindings: {
    isComplete: '<',
    isLockable: '<',
    onLock: '&',
    whenComplete: '@',
    whenIncomplete: '@',
    modalTitle: '@',
    modalBody: '@',
    noModal: '<',
    showPrint: '<',
    modalButtonClass: '@',
    modalButtonConfirmText: '@',
    modalButtonDenyText: '@',
    modalClass: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-summary-form/index.js
 ** module id = 101
 ** module chunks = 0
 **/